module.exports = __webpack_public_path__ + "static/media/1.628c5a1e.jpg";